/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_DurationInputs */

const en_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const fr_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duree`)
};

const de_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const it_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

const ru_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность`)
};

const es_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const zh_cn2_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期间`)
};

const ja_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間隔`)
};

const hi_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_editor_duration = /** @type {(inputs: Editor_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Editor_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_duration = /** @type {((inputs?: Editor_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_duration(inputs)
	if (locale === "de") return de_editor_duration(inputs)
	if (locale === "it") return it_editor_duration(inputs)
	if (locale === "ru") return ru_editor_duration(inputs)
	if (locale === "es") return es_editor_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_duration(inputs)
	if (locale === "ja") return ja_editor_duration(inputs)
	if (locale === "hi") return hi_editor_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_duration(inputs)
	return en_editor_duration(inputs)
});